'use strict';

var _regeneratorRuntime = require("/codebuild/output/src1753007849/src/nepal/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/codebuild/output/src1753007849/src/nepal/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('util'),
    promisify = _require.promisify;

var crypto = require('crypto');

var randomBytesAsync = promisify(crypto.randomBytes);
var urlSafeCharacters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~'.split('');
var numericCharacters = '0123456789'.split('');
var distinguishableCharacters = 'CDEHKMPRTUWXY012458'.split('');
var asciiPrintableCharacters = '!"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~'.split('');
var alphanumericCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.split('');

var generateForCustomCharacters = function generateForCustomCharacters(length, characters) {
  // Generating entropy is faster than complex math operations, so we use the simplest way
  var characterCount = characters.length;
  var maxValidSelector = Math.floor(0x10000 / characterCount) * characterCount - 1; // Using values above this will ruin distribution when using modular division

  var entropyLength = 2 * Math.ceil(1.1 * length); // Generating a bit more than required so chances we need more than one pass will be really low

  var string = '';
  var stringLength = 0;

  while (stringLength < length) {
    // In case we had many bad values, which may happen for character sets of size above 0x8000 but close to it
    var entropy = crypto.randomBytes(entropyLength);
    var entropyPosition = 0;

    while (entropyPosition < entropyLength && stringLength < length) {
      var entropyValue = entropy.readUInt16LE(entropyPosition);
      entropyPosition += 2;

      if (entropyValue > maxValidSelector) {
        // Skip values which will ruin distribution when using modular division
        continue;
      }

      string += characters[entropyValue % characterCount];
      stringLength++;
    }
  }

  return string;
};

var generateForCustomCharactersAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(length, characters) {
    var characterCount, maxValidSelector, entropyLength, string, stringLength, entropy, entropyPosition, entropyValue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Generating entropy is faster than complex math operations, so we use the simplest way
            characterCount = characters.length;
            maxValidSelector = Math.floor(0x10000 / characterCount) * characterCount - 1; // Using values above this will ruin distribution when using modular division

            entropyLength = 2 * Math.ceil(1.1 * length); // Generating a bit more than required so chances we need more than one pass will be really low

            string = '';
            stringLength = 0;

          case 5:
            if (!(stringLength < length)) {
              _context.next = 21;
              break;
            }

            _context.next = 8;
            return randomBytesAsync(entropyLength);

          case 8:
            entropy = _context.sent;
            // eslint-disable-line no-await-in-loop
            entropyPosition = 0;

          case 10:
            if (!(entropyPosition < entropyLength && stringLength < length)) {
              _context.next = 19;
              break;
            }

            entropyValue = entropy.readUInt16LE(entropyPosition);
            entropyPosition += 2;

            if (!(entropyValue > maxValidSelector)) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("continue", 10);

          case 15:
            string += characters[entropyValue % characterCount];
            stringLength++;
            _context.next = 10;
            break;

          case 19:
            _context.next = 5;
            break;

          case 21:
            return _context.abrupt("return", string);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function generateForCustomCharactersAsync(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var generateRandomBytes = function generateRandomBytes(byteLength, type, length) {
  return crypto.randomBytes(byteLength).toString(type).slice(0, length);
};

var generateRandomBytesAsync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(byteLength, type, length) {
    var buffer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return randomBytesAsync(byteLength);

          case 2:
            buffer = _context2.sent;
            return _context2.abrupt("return", buffer.toString(type).slice(0, length));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function generateRandomBytesAsync(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var allowedTypes = [undefined, 'hex', 'base64', 'url-safe', 'numeric', 'distinguishable', 'ascii-printable', 'alphanumeric'];

var createGenerator = function createGenerator(generateForCustomCharacters, generateRandomBytes) {
  return function (_ref3) {
    var length = _ref3.length,
        type = _ref3.type,
        characters = _ref3.characters;

    if (!(length >= 0 && Number.isFinite(length))) {
      throw new TypeError('Expected a `length` to be a non-negative finite number');
    }

    if (type !== undefined && characters !== undefined) {
      throw new TypeError('Expected either `type` or `characters`');
    }

    if (characters !== undefined && typeof characters !== 'string') {
      throw new TypeError('Expected `characters` to be string');
    }

    if (!allowedTypes.includes(type)) {
      throw new TypeError("Unknown type: ".concat(type));
    }

    if (type === undefined && characters === undefined) {
      type = 'hex';
    }

    if (type === 'hex' || type === undefined && characters === undefined) {
      return generateRandomBytes(Math.ceil(length * 0.5), 'hex', length); // Need 0.5 byte entropy per character
    }

    if (type === 'base64') {
      return generateRandomBytes(Math.ceil(length * 0.75), 'base64', length); // Need 0.75 byte of entropy per character
    }

    if (type === 'url-safe') {
      return generateForCustomCharacters(length, urlSafeCharacters);
    }

    if (type === 'numeric') {
      return generateForCustomCharacters(length, numericCharacters);
    }

    if (type === 'distinguishable') {
      return generateForCustomCharacters(length, distinguishableCharacters);
    }

    if (type === 'ascii-printable') {
      return generateForCustomCharacters(length, asciiPrintableCharacters);
    }

    if (type === 'alphanumeric') {
      return generateForCustomCharacters(length, alphanumericCharacters);
    }

    if (characters.length === 0) {
      throw new TypeError('Expected `characters` string length to be greater than or equal to 1');
    }

    if (characters.length > 0x10000) {
      throw new TypeError('Expected `characters` string length to be less or equal to 65536');
    }

    return generateForCustomCharacters(length, characters.split(''));
  };
};

module.exports = createGenerator(generateForCustomCharacters, generateRandomBytes);
module.exports.async = createGenerator(generateForCustomCharactersAsync, generateRandomBytesAsync);